<script setup lang="ts">
import AppButton from "@/components/atoms/button/AppButton.vue";
import { computed } from "vue";
import { Gift } from "@/types/Gift";
import { formatNumber } from "@/utils/number";
import { authStore } from "@/store/auth";

const props = defineProps<{
  gift: Gift;
}>();
const emits = defineEmits(["click"]);

const canExchange = computed(() => {
  return authStore.user!.caisukePoint >= props.gift.requiredPoint;
});
</script>

<template>
  <div class="gift-item">
    <p class="gift-item__title text-black text-size-18 text-weight-600">
      <span data-testid="giftName">{{ gift.giftName }}</span>
    </p>
    <div class="d-flex align-items-end justify-content-between mt-3">
      <div>
        <p class="text-mild text-size-12">使用ポイント</p>
        <p class="text-size-18 text-weight-600" data-testid="requiredPoint">
          {{ formatNumber(gift.requiredPoint) }}
        </p>
      </div>
      <AppButton
        variant="primary"
        size="sm"
        :disabled="!canExchange"
        @click="emits('click', gift)"
        >交換する</AppButton
      >
    </div>
  </div>
</template>

<style scoped lang="scss">
.gift-item {
  padding: 1rem 1.5rem;
  background: url("~@/assets/img/bg_ticket.png") no-repeat center center;
  background-size: 100% 100%;

  &__title span {
    background: linear-gradient(
      to top,
      #fff19a,
      #fff19a 45%,
      rgba(#fff19a, 0) 45.1%
    );
  }
}
</style>
